import styled from "styled-components";

export const EmptyStateStyles = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: ${({ theme }) => theme.spacing[8]};
  padding: ${({ theme }) => theme.spacing[64]}
    ${({ theme }) => theme.spacing[24]};
  background: ${({ theme }) => theme.colors.semantic.container.white};

  .es-icon {
    color: ${({ theme }) => theme.colors.semantic.icon.weak};
    opacity: 0.6;
    margin-bottom: ${({ theme }) => theme.spacing[8]};
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .es-title {
    font-size: ${({ theme }) => theme.typography.title.t1.size};
    line-height: ${({ theme }) => theme.typography.title.t1.lineHeight};
    font-weight: ${({ theme }) => theme.typography.title.t1.weight};
    color: ${({ theme }) => theme.colors.semantic.text.strong};
    margin: 0;
  }

  .es-subtitle {
    font-size: ${({ theme }) => theme.typography.body.b2.size};
    line-height: ${({ theme }) => theme.typography.body.b2.lineHeight};
    color: ${({ theme }) => theme.colors.semantic.text.weak};
    margin: 0;
    text-align: center;
    max-width: 360px;
  }
`;
